import { Helmet } from "react-helmet-async";

type Props = {
  title?: string;
  description?: string;
  siteUrl: string;
  canonicalPath?: string;
  image?: string;
  locale?: string;
  siteName?: string;
  indexable?: boolean;
  jsonLd?: Record<string, unknown>;
};

export default function Seo({
  title,
  description,
  siteUrl,
  canonicalPath = "/",
  image,
  locale = "en_GB",
  siteName = "Community Platform",
  indexable = true,
  jsonLd,
}: Props) {
  const canonical = `${siteUrl}${canonicalPath}`;
  const robots = indexable ? "index, follow" : "noindex, nofollow";
  const fullTitle = title ? `${title} • ${siteName}` : siteName;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || ""} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ""} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || ""} />
      {image && <meta name="twitter:image" content={image} />}

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}